import Typography from '@mui/material/Typography'
import React from 'react'
import { useTranslation } from 'react-i18next'
import EmptyPage from '../Elements/EmptyPage'

interface EmptyFamilyProfileProps {
  isLoading: boolean
}

const EmptyFamilyProfile: React.FC<EmptyFamilyProfileProps> = (props) => {
  const { t } = useTranslation()

  return (
    <EmptyPage
      {...props}
      message={
        <Typography variant="subtitle1" component="p">
          {t(
            'FamilyProfile.EmptyState.Instructions',
            'No Family Profile information available.'
          )}
        </Typography>
      }
    />
  )
}

export default EmptyFamilyProfile
